import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/GetInfluencerRateCard.graphql';
import { Query, QuerygetInfluencerRateCardArgs } from '../../__generated__/globalTypes';

export const useGetInfluencerRateCardQuery = (options?: QueryHookOptions<Query, QuerygetInfluencerRateCardArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerygetInfluencerRateCardArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useGetInfluencerRateCardLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerygetInfluencerRateCardArgs>
): QueryResult<Query, QuerygetInfluencerRateCardArgs> & {
  getGetInfluencerRateCard: LazyQueryExecFunction<Query, QuerygetInfluencerRateCardArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getGetInfluencerRateCard, result] = useLazyQuery<Query, QuerygetInfluencerRateCardArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getGetInfluencerRateCard, ...result };
};

export const useGetInfluencerRateCardPromiseQuery = () => {
  const client = useApolloClient();

  const getGetInfluencerRateCard = useCallback(
    (options?: Omit<QueryOptions<QuerygetInfluencerRateCardArgs, Query>, 'query'>) =>
      client.query<Query, QuerygetInfluencerRateCardArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getGetInfluencerRateCard };
};
// Suspense Query Hooks
export const useGetInfluencerRateCardSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerygetInfluencerRateCardArgs>
) => {
  const result = useSuspenseQuery<Query, QuerygetInfluencerRateCardArgs>(QUERY, {
    ...options
  });

  return result;
};
